module.exports = __webpack_public_path__ + "media/images/icons/tag-9c1b23c65efc798ddfbb480df0292ad8.svg";